import {
    StrictMode
} from "react";

import {
    createRoot
} from "react-dom/client";

import {
    App
} from "./app/App.js";

import "./styles/style.css";

const rootElement =
    document.getElementById(
        "root"
    );

if (!rootElement) {
    throw new Error(
        "Missing #root application container."
    );
}

createRoot(
    rootElement
).render(
    <StrictMode>
        <App />
    </StrictMode>
);